import script from "./GroupsSchedule.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupsSchedule.vue?vue&type=script&lang=ts&setup=true"

import "./GroupsSchedule.vue?vue&type=style&index=0&id=1b5a0b87&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5a0b87"]])

export default __exports__